import IconAccommodationBanner from "@Icons/banners/IconAccommodationBanner";
import IconType from "@/types/Icon.type";

function IconCabinPassengerClass(props: IconType) {
    return (
        <IconAccommodationBanner
            {...props}
        />
    )
}

export default IconCabinPassengerClass